<template>
	<div v-if="report && Object.keys(report['customers-frequency'] || {}).length" class="report">
		Hello World!
	</div>
</template>

<script>
  import KendoChart from '@/components/kendo-chart/kendo-chart';
  import {momentMixin, numeralMixin, stringMixin} from '@/modules/neodash/mixins';
  import {PRINT_GET_PRINT_MODE} from '@/store/modules/print/types';

  import {
    REPORT_GET_LOGO,
    REPORT_GET_REPORTS,
    REPORT_GET_SUBTITLE,
    REPORT_GET_TITLE
  } from '@/modules/neodash/store/modules/report/types';
  import _ from 'lodash';
  import {mapGetters} from 'vuex';

  export default {
    props: {
      dataQuery: {
        type: Object,
        required: true
      }
    },

    data() {
      return {};
    },

    computed: {
      ...mapGetters({
        report: REPORT_GET_REPORTS,
        printMode: PRINT_GET_PRINT_MODE,
        title: REPORT_GET_TITLE,
        subtitle: REPORT_GET_SUBTITLE,
        logo: REPORT_GET_LOGO
      })
    },

    mounted() {
      if (_.size((this.report || {})['customers-frequency'])) {
        this.populateData(this.report['customers-frequency'].data);
      }
    },

    mixins: [numeralMixin, momentMixin, stringMixin],

    methods: {},

    watch: {
      report(report) {
        if (_.size((report || {})['customers-frequency'])) {
          this.populateData(this.report['customers-frequency'].data);
        }
      }
    },

    components: {
      KendoChart
    }
  };
</script>

<style lang="scss" scoped>
	.link {
		cursor: pointer !important;

		&:hover {
			color: #2185D0 !important;
		}
	}
</style>
